import type { EnvironmentUtils } from '@change-corgi/core/environment';

import { AMPLITUDE_CONFIG } from '#config/amplitude';

import type { Session } from '#src/shared/session';

import type { AmplitudeGuidesAndSurveys } from '#src/app/shared/utils/amplitudeGuidesAndSurveys';
import {
	createAmplitudeGuidesAndSurveys as createAmplitudeGuidesAndSurveysBase,
	createFakeAmplitudeGuidesAndSurveys,
} from '#src/app/shared/utils/amplitudeGuidesAndSurveys';

type Options = {
	environment: EnvironmentUtils;
	session: Session;
	/**
	 * bots don't need guides and surveys, so the fake is used
	 */
	isBot: boolean;
};

export function createAmplitudeGuidesAndSurveys(options: Options): AmplitudeGuidesAndSurveys {
	const apiKey = AMPLITUDE_CONFIG[options.environment.getEnvironment()];
	if (apiKey && !options.isBot) {
		return createAmplitudeGuidesAndSurveysBase({
			apiKey,
			deviceId: options.session.uuid,
			locale: options.session.locale.localeCode,
		}).setLoggingEnabled(process.env.NODE_ENV === 'development');
	}
	return createFakeAmplitudeGuidesAndSurveys().setLoggingEnabled(false);
}
